<div class="mb-3">
  <label *ngIf="hasLabel" [id]="labelId" class="form-label">{{ label | translate }}</label>
  <ng-content></ng-content>
  
  <div [class]="radioGroupClass">
    <div 
      *ngFor="let option of options" 
      class="form-check"
    >
      <input
        type="radio"
        class="form-check-input"
        name="{{ name }}"
        [formControl]="field"
        [id]="'radio-' + name + '-' + option.value"
        [value]="option.value"
        (change)="change.emit($event)"
      />
      <label class="form-check-label" [for]="'radio-' + name + '-' + option.value">
        {{ option.label | translate }}
      </label>
    </div>
  </div>

  <div *ngIf="hasHint" class="form-text">
    {{ hint | translate }}
    <ng-content select="[hint-link]"></ng-content>
  </div>
</div>
